import { apiUrl } from '../../../../../constants/global';
import axios from 'axios';
import { getLoggedUser } from '../../../../../state/user';

const user = getLoggedUser();
const endpoint = apiUrl + 'v2';



async function createSitePassRequest(payload, isFormData = false) {
    const config = {
        headers: {}
    };

    if (isFormData) {
        // For FormData, let the browser set the Content-Type with boundary
        // Don't set Content-Type manually for FormData
    } else {
        config.headers['Content-Type'] = 'application/json';
    }

    try {
        const { data: response } = await axios.post(`${endpoint}/rest/vehicles/bulk-register`, payload, config);
        return response;
    } catch (error) {
        console.error('API Error:', error);
        return {
            success: false,
            message: error.response?.data?.message || 'Something went wrong',
            status: error.response?.status || 500,
            error: error,
        };
    }
}

async function getVehicleType(filters = {}) {
  const query = new URLSearchParams(filters).toString();

  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const response = await axios.get(`${endpoint}/rest/vehicle-types?${query}`, config);
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}


export {  createSitePassRequest  ,  getVehicleType};
